













































import { Component, Vue } from 'vue-property-decorator'
import { hls, Load } from '@/units'
import { lowerCase } from '@/utils'

@Component
export default class Permissions extends Vue {
  // __DATA
  private search: string = ''
  private active: any = null

  // __CREATED
  public async created () {
    Load(this, true)

    await this.$store.dispatch('APP.USERS/callPer')
    this.$store.dispatch('APP.USERS/callVie')

    Load(this, false)
  }

  // __METHODS
  private edit (data: any): void {
    this.$emit('events', { type: 'edit', data })
  }

  private remove (data: any): void {
    const conf: boolean = confirm(`Disabled [${data.name}]?`)
    if (conf) {
      this.$emit('events', { type: 'remove', data })
    }
  }

  private h (val: string): string {
    return hls(val, this.search)
  }

  // __COMPUTED
  private get store (): any {
    const search: string = lowerCase(this.search)
    let permissions: any = this.$store.getters['APP.USERS/permissions']

    if (this.search) {
      permissions = permissions.filter((x: any) => lowerCase(x.name).includes(search))
    }

    if (this.active !== null) {
      permissions = permissions.keep('isActive', this.active)
    }

    return permissions
  }

  /**
   * DB Facker.
   */
  private get db (): any {
    return {
      active: [
        { id: 1, name: this.$t('enabled') },
        { id: 0, name: this.$t('disabled') }
      ]
    }
  }
}
